module.exports = __webpack_public_path__ + "static/CookieRun-Bold.subset-4636374c7aab83143a85899e31d60fcc.woff2";